export default __webpack_public_path__ + "static/media/foto-carlos.7f518806.jpg";